import { useState, useRef, useEffect } from 'react';
import { IconInfoCircleFilled, IconChevronDown, IconChevronUp } from '@tabler/icons-react';

const ACCENT = '#0a84ff';
const FONT = '"Public Sans", sans-serif';

export default function TipBlue({ children, style, openUp = true, alignRight = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div ref={ref} className="relative inline-flex" style={style}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 shrink-0 cursor-pointer transition-colors duration-200 ease-out active:scale-[0.98]"
        style={{
          height: '36px',
          padding: '0 14px 0 6px',
          borderRadius: '9999px',
          backgroundColor: 'rgba(10, 132, 255, 0.12)',
          border: 'none',
        }}
        aria-expanded={open}
      >
        <span
          className="flex items-center justify-center shrink-0"
          style={{
            width: '20px',
            height: '20px',
            borderRadius: '9999px',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
          }}
        >
          <IconInfoCircleFilled size={12} color={ACCENT} />
        </span>
        <span style={{ fontSize: '13px', fontWeight: 600, color: ACCENT, fontFamily: FONT }}>
          Tip
        </span>
        {open ? (
          <IconChevronUp size={14} color={ACCENT} />
        ) : (
          <IconChevronDown size={14} color={ACCENT} />
        )}
      </button>

      {open && (
        <div
          className={`absolute z-50 ${openUp ? 'bottom-full mb-2' : 'top-full mt-2'} ${alignRight ? 'right-0' : 'left-0'}`}
          style={{
            width: '400px',
            maxWidth: 'calc(100vw - 24px)',
            backgroundColor: 'rgba(255, 255, 255, 0.04)',
            border: '1px solid rgba(255, 255, 255, 0.16)',
            borderRadius: '16px',
            padding: '12px 14px',
            boxShadow: '0 24px 64px rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(24px)',
            WebkitBackdropFilter: 'blur(24px)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
            <span
              className="flex items-center justify-center shrink-0"
              style={{ width: '16px', height: '16px', borderRadius: '9999px', backgroundColor: 'rgba(255, 255, 255, 0.15)' }}
            >
              <IconInfoCircleFilled size={10} color={ACCENT} />
            </span>
            <span style={{ fontSize: '12px', fontWeight: 700, color: ACCENT, fontFamily: FONT, letterSpacing: '0.02em' }}>
              Tip
            </span>
          </div>
          <span
            style={{
              fontSize: '13px',
              fontWeight: 500,
              color: 'rgba(255, 255, 255, 0.78)',
              fontFamily: FONT,
              lineHeight: '1.5',
            }}
          >
            {children}
          </span>
        </div>
      )}
    </div>
  );
}